import { DashboardLayout } from "../layouts/DashboardLayout";
import { PermissionDenied } from "../components/ui/PermissionDenied";
import { useAuth } from "../contexts/AuthContext";
import { ExtendEnrollmentsCard } from "../components/globalChanges/ExtendEnrollmentsCard";
import { UpdateDeviceLimitCard } from "../components/globalChanges/UpdateDeviceLimitCard";

const REQUIRED_PERMISSION = "globalChanges:read";

export default function GlobalChangesPage() {
  const { hasPermission } = useAuth();

  if (!hasPermission(REQUIRED_PERMISSION)) {
    return <PermissionDenied requiredPermission={REQUIRED_PERMISSION} />;
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col gap-1">
          <h2 className="text-2xl font-bold tracking-tight text-gray-900">
            Global Changes
          </h2>
          <p className="text-gray-500">
            Apply bulk changes to enrollment settings across one or more
            courses.
          </p>
        </div>

        <ExtendEnrollmentsCard />
        <UpdateDeviceLimitCard />

        <div className="text-xs text-gray-500 bg-amber-50 border border-amber-200 rounded-lg p-3">
          Both operations are auditable and reversible only via the database.
          Consider testing on a small course first.
        </div>
      </div>
    </DashboardLayout>
  );
}